// returns a new object with the values at each key mapped using mapFn(value)
export const objectMap = (object, mapFn) =>
  Object.keys(object).reduce((result, key) => {
    result[key] = mapFn(object[key]);
    return result;
  }, {});

export const logger = (params) => {
  const loggingEnabled = true;
  if (loggingEnabled) {
    console.log(...params);
  }
};

export const logFormEvent = (type) => console.log.bind(console, type);

/**
 * Validates a South African ID number.
 * Returns an error message string if invalid, or null if valid (or if the value
 * is not a 13-digit string and should be treated as a passport number).
 */
export const validateSaId = (value) => {
  if (!value) return null;

  // Only apply SA ID rules when the input is exactly 13 digits.
  // Otherwise treat it as a passport number and apply basic format validation.
  if (!/^\d{13}$/.test(value)) {
    if (!/^[A-Za-z0-9]+$/.test(value)) {
      return "Invalid ID/Passport number: only letters and digits are allowed.";
    }
    if (!/\d/.test(value)) {
      return "Invalid passport number: must contain at least one digit.";
    }
    return null;
  }

  // Validate the date-of-birth portion (YYMMDD).
  const month = parseInt(value.substring(2, 4), 10);
  const day = parseInt(value.substring(4, 6), 10);
  if (month < 1 || month > 12 || day < 1 || day > 31) {
    return "Invalid South African ID number: date of birth is not valid.";
  }

  // Citizenship digit (index 10) must be 0 (SA citizen) or 1 (permanent resident).
  const citizenship = parseInt(value[10], 10);
  if (citizenship !== 0 && citizenship !== 1) {
    return "Invalid South African ID number: citizenship digit must be 0 or 1.";
  }

  // Luhn check-digit validation.
  const digits = value.split("").map(Number);
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    const d = digits[i];
    if (i % 2 === 1) {
      // Odd zero-based index = even position from right = double it.
      const doubled = d * 2;
      sum += doubled > 9 ? doubled - 9 : doubled;
    } else {
      sum += d;
    }
  }
  const expectedCheck = (10 - (sum % 10)) % 10;
  if (expectedCheck !== digits[12]) {
    return "Invalid South African ID number: check digit is incorrect. Please verify the number.";
  }

  return null;
};
